export const iconFontAwesomeDevicesHardwareBlenderPhone = (
	<i className="fa-solid fa-blender-phone"></i>
);
